import { AppSelectBox } from 'components';
import SelectBoxV2 from 'components/Inputs/SelectBoxV2';
import useES from 'hooks/API/GET/useES';
import { Fragment } from 'react';

function ESDropDown(props) {
  const {
    enableAPI,
    value,
    handleChange,
    labelClass,
    version,
    defaultLook = true,
    label = 'Board',
  } = props;
  const { fieldErrors = {}, dependencies = {} } = props;

  const { query = '' } = dependencies;
  const queryParams = `?mode=dropdown${query ? `&${query}` : ``}`;
  const { data, isLoading, isError } = useES({ enabled: enableAPI, queryParams });

  if (version === 'v2') {
    return (
      <SelectBoxV2
        labelProps={{ label: 'Board', className: labelClass }}
        fieldErrors={fieldErrors}
        selectProps={{
          isLoading,
          options: data?.data || [],
          value: data?.data?.find((item) => item?._id === value) ?? null,
          getOptionLabel: (item) => item.name,
          getOptionValue: (item) => item._id,
          onChange: (args) => {
            if (args._id) handleChange({ target: { value: args._id } }, args);
          },
        }}
      />
    );
  }

  return (
    <AppSelectBox
      labelProps={{ label, className: labelClass }}
      selectProps={{
        value,
        onChange: (event) => {
          const obj = data?.data?.find?.((item) => item._id === event.target.value);
          if (obj && obj.value) obj._id = obj.value;

          handleChange(event, obj);
        },
      }}
      fieldErrors={fieldErrors}
      options={data?.data?.map((option) => {
        return {
          label: option.name,
          value: option._id,
        };
      })}
      onChangeEvent={(args) => {
        if (args.value)
          handleChange({ target: { value: args.value } }, { ...args, _id: args.value });
      }}
      defaultLook={defaultLook}
    >
      {isLoading ? (
        <option disabled value="">
          Loading...
        </option>
      ) : isError ? (
        <option disabled value="">
          Failed to load list
        </option>
      ) : (
        <Fragment>
          {data?.data?.length > 0 ? (
            <Fragment>
              <option value="">Choose</option>
              {data?.data?.map((option) => {
                return (
                  <option key={option._id} value={option._id}>
                    {option.name}
                  </option>
                );
              })}
            </Fragment>
          ) : (
            <option value="">No options found</option>
          )}
        </Fragment>
      )}
    </AppSelectBox>
  );
}

ESDropDown.defaultProps = {
  handleChange: () => {},
};

export default ESDropDown;
